import {BaseModel} from '../base.model';


export class PermissionModel extends BaseModel {
	id: number;
	nom: string;
	titre: string;
	estActive: boolean;
	enfants: PermissionModel[];

	constructor() {
		super();
	}
}

